import { create } from 'zustand';
import { Specialty } from '../../../models/Specialist';

interface ISpecialties {
  specialties: Specialty[];
  specialtySelected?: Specialty;
  setSpecialties: (props: Specialty[]) => void;
  setSpecialtySelected: (props: Specialty) => void;
}

export const useSpecialties = create<ISpecialties>(set => ({
  specialties: [],
  setSpecialties: value => set(() => ({ specialties: value })),
  setSpecialtySelected: value => set(() => ({ specialtySelected: value }))
}));
